<template>
  <div>
    <template v-if="proptyp === 'checkout'">
      <template v-for="prop in returnProp" >
        <div :class="{'active': prop.value === 1}" class="form-check pl-0" :key="prop.PropertyId">
          <label :for="prop.PropertyId" class="d-flex align-items-center">
            <div class="check" :class="{'checked' : prop.value === 1}">
              <i class="fa fa-check" v-if="prop.value === 1"></i>
            </div>
            <img alt="customer property" :src="img" class="mr-2" />
            <div class="form-check flex-fill mb-0">
              <input
                  type="checkbox"
                  :value="prop.value"
                  v-model="prop.value"
                  :id="prop.PropertyId"
                  class="form-check-input d-none"
                  @change="customerPropCheck(prop)"
                  aria-labelledby="prop.PropertyId"
              />
              <div class="customerPropText" v-html="desc"></div>
            </div>
          </label>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "customerprops",
  props: {
    user: {
      type: Object,
      default: null
    },
    showprop: {
      type: Array,
      required: true
    },
    proptyp: {
      type: String,
      required: true
    },
    labeltext: String,
    desc: String,
    img: String
  },
  data() {
    return {
      userProps: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    customerPropCheck(prop) {
      prop.value = prop.value ? 1 : 0;
      const data = {
        propertyId: prop.PropertyId,
        customerId: ceresStore.state.user.userData.id,
        content: prop.value,
        lang: App.language
      };
      $.ajax({
        type: 'POST',
        url: '/customerprops/save/',
        data: data,
        dataType: 'json',
        success(response) {
      /*    console.log(response);*/
        },
        error(jqXHR, textStatus, errorThrown) {
          console.error(errorThrown);
        }
      });
    },
    getData() {
      if (!this.user) return;
      const userid = this.user.id;
      const language = App.language;
      const showProp = this.showprop;
      $.ajax({
        type: 'GET',
        url: `/customerprops/${userid}`,
        dataType: 'json',
        success: (data) => {
          const toReturn = data.filter(item => showProp.includes(item.Property.propertyId)).map(item => {
            item.Name = item.Name.find(name => name.lang === language).name;
            item.PropertyId = item.Property.propertyId;
            item.value = item.Property.values.reduce((acc, value) => {
              const increment = item.PropertyId === 93 ? parseInt(value.value) : value.value;
              return acc + increment;
            }, item.value || 0);
            return item;
          });

          if (toReturn.length === 0) {
            this.fetchDefaultProperties(showProp, language);
          } else {
            this.userProps = toReturn;
          }
        },
        error(jqXHR, textStatus, errorThrown) {
          console.error(errorThrown);
        }
      });
    },
    fetchDefaultProperties(showProp, language) {
      $.ajax({
        type: 'POST',
        url: '/customerprops/getnames/',
        data: { propnames: showProp },
        dataType: 'json',
        success: (returnData) => {
          this.userProps = returnData.flatMap(itemGroup =>
              itemGroup.map(item => item.lang === language ? {
                Name: item.name,
                Property: item,
                PropertyId: item.propertyId,
                value: ''
              } : [])
          );
        },
        error(jqXHR, textStatus, errorThrown) {
          console.error(errorThrown);
        }
      });
    }
  },
  computed: {
    returnProp() {
      return this.userProps;
    }
  }
};
</script>


